import Accordion from '@/common/components/Accordion';
import { CompanyData } from '@/features/companies/types/companies.type';
import { UpdateUserAccessModal } from '@/features/privateCompanies/pages/Update/components/UpdateUserAccessModal';
import { CircleChevronDownIcon } from 'lucide-react';
import { allowedDriverEquipmentBranchHierarchyForConsumption } from '../constants/allowedDriverEquipmentBranchHierarchyForConsumption.constant';
import { branchHierarchyForUserAccess } from '../constants/branchHierarchyForUserAccess.constant';
import { driverLicenseRequirementsForConsumptions } from '../constants/driverLicenseRequirementsForConsumptions.constant';

const UserAccessSection = ({ company }: { company?: CompanyData }) => {
  const userAccessItems = [
    {
      label: 'Equipamentos que o usuário pode transacionar',
      value: company?.allowed_driver_equipment_branch_hierarchy_for_consumption
        ? allowedDriverEquipmentBranchHierarchyForConsumption[company.allowed_driver_equipment_branch_hierarchy_for_consumption]
        : '',
    },
    {
      label: 'Filiais que o usuário pode acessar os recursos',
      value: company?.branch_hierarchy_for_user_access
        ? branchHierarchyForUserAccess[company.branch_hierarchy_for_user_access]
        : '',
    },
    {
      label: 'Validar CNH',
      value: company?.driver_license_requirements_for_consumptions
        ? driverLicenseRequirementsForConsumptions[company.driver_license_requirements_for_consumptions]
        : '',
    },
  ];

  return (
    <Accordion
      defaultOpen
      head={(
        <div className="flex items-center gap-x-3">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateUserAccessModal company={company} />
          </div>

          <p className='text-xl'>
            Acessos de Usuários
          </p>
        </div>
      )}
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={(
        <div className='flex flex-col gap-4'>
          {userAccessItems.map((item, i) => (
            <div key={`general_politics_${i}`} className='flex items-center gap-2'>
              <p>
                {item.label}:
              </p>

              <div className='flex items-center gap-1 text-white-400'>
                <CircleChevronDownIcon strokeWidth={1.5} />

                <p>
                  {item.value || '--'}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    />
  )
}

export default UserAccessSection;
